
import { InputControlCheckBoxViewModel } from '@/entities/InputControlCheckBoxViewModel';
import { Root } from '@/main';
import { Component, Prop, toNative, Vue, Watch } from 'vue-facing-decorator';
@Component({
  components: {},
})
class InputControlCheckBox extends Vue {
  @Prop() inputData!: InputControlCheckBoxViewModel[];
  private localInputData: InputControlCheckBoxViewModel[] = [];
  private loadingImage: string = require('@/assets/Images/loading.png');
  private mounted() {
    this.localInputData = structuredClone(this.inputData);
    Root.on('reset-input-checkbox-data', () => {
      this.localInputData = structuredClone(this.inputData);
    });
  }
  private AddOrRemoveItem(id: number) {
    const index = this.localInputData.findIndex((item) => item.Id === id);
    if(index !== -1) {
      this.localInputData[index].IsChecked = !this.localInputData[index].IsChecked;
      this.$emit('checked-items', this.localInputData);
    }
  }
  // Used to check whether inputControlData has value to display or not
  private ShowInputControlContainer() {
    return this.localInputData && this.localInputData.length !== 0;
  }
  // Detect change in inputData
  @Watch('inputData')
  private CheckChangeInInputData(val: InputControlCheckBoxViewModel[]) {
    this.localInputData = structuredClone(val);
  }
}
export default toNative(InputControlCheckBox);
